import { graphql } from '@/gql';
import { type CreateOperatorMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const createOperator = async (data: CreateOperatorMutationVariables['data']) => {
  const response = await mutationExecute({
    variables: { data },
    mutation: graphql(`
      mutation CreateOperator($data: OperatorInputType!) {
        createOperator(data: $data) {
          id
          firstName
          lastName
          email
          phoneNumber
          textNumber
          language1
          language2
          workerSid
          departments
          registrationCallPriorityOverride
          slackId
          slackWebHook
          slackAlertWebHook
          defaultType
          isDefaultOnly
          closedAt
          slingUserId
          teamLeadId
          isRehireEligible
          suspendedAt
          isSuspended
          isRecordAllCalls
          isEnableRegFlowView
          isVerified
        }
      }
    `),
  });

  return response.data?.createOperator!;
};
